import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Always-visible "My profile" entry with progress; a link, never a gate.
export function ProfileNavLink({ onNavigate, testId = "nav-my-profile", className = "" }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [pct, setPct] = useState(null);

  useEffect(() => {
    if (!user) { setPct(null); return; }
    let live = true;
    api.get("/profile/completeness")
      .then(({ data }) => { if (live) setPct(typeof data?.percent === "number" ? Math.round(data.percent) : null); })
      .catch(() => { if (live) setPct(null); });
    return () => { live = false; };
  }, [user, pathname]);

  const label = pct == null ? "My profile" : `My profile, ${pct}% complete`;
  return (
    <Link to="/profile" onClick={onNavigate} data-testid={testId} aria-label={label} title={label}
      className={`group inline-flex min-h-[40px] flex-col justify-center gap-1 rounded-md px-1.5 text-[#4C1D95] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4C1D95] ${className}`}>
      <span className="flex items-baseline justify-between gap-2 text-[11px] font-medium leading-none whitespace-nowrap">
        <span className="group-hover:underline underline-offset-2">Profile</span>
        {pct != null && <span data-testid={`${testId}-pct`} className="font-mono text-stone-600">{pct}%</span>}
      </span>
      {pct != null && (
        <span className="block h-1 w-16 overflow-hidden rounded-full bg-stone-200" aria-hidden="true">
          <span className="block h-full rounded-full bg-[#4C1D95] transition-[width] duration-300" style={{ width: `${pct}%` }} />
        </span>
      )}
    </Link>
  );
}
